import * as React from 'react';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { useRemoteResource } from '../../../../commonv3/hooks/useRemoteResource';
import { UserSurveySubmissionApis } from '../../../apis/surveySubmissions';
import { SurveyKeys } from '../../../../commonv3/types/surveys';
import CareerChangeBannerPc from './images/careerchange_survey-pc.jpg';
import CareerChangeBannerSp from './images/careerchange_survey-sp.jpg';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';
import './topPaneBanners.module.scss';
import { Link } from 'react-router-dom';
import { V3Routes } from '../../../routes';

const MINIMUM_COURSE_ACTIVATION_COUNT = 7;
const MINIMUM_JOIN_DAYS = 90;

const CareerChangeSurveyBanner = observer(() => {
    const { isSp } = useViewportState();
    return (
        <Link to={V3Routes.survey(SurveyKeys.CAREER_CHANGE)}>
            <img styleName="banner" src={isSp ? CareerChangeBannerSp : CareerChangeBannerPc} />
        </Link>
    );
});

const shouldShowCareerChangeBanner = (submittedCareer) => {
    const { getValue } = GlobalStatesV3.currentUser;
    // The target user must have been a member for 90 months
    if (submittedCareer.isError()) {
        return false;
    }
    if (!getValue('v3_member', false)) {
        return false;
    }
    // The target user must have been a member for 90 months
    if (getValue('days_since_join', 0) < MINIMUM_JOIN_DAYS) {
        return false;
    }
    if (getValue('activated_course_count', 0) < MINIMUM_COURSE_ACTIVATION_COUNT) {
        return false;
    }
    if (submittedCareer.get()) {
        return false;
    }
    return true;
};

export const TopPaneBanners = observer(() => {
    const [submittedCareer] = useRemoteResource(() =>
        UserSurveySubmissionApis.hasSurveySubmissionWithin(SurveyKeys.CAREER_CHANGE)
    );
    if (submittedCareer.loading) {
        return null;
    }
    if (shouldShowCareerChangeBanner(submittedCareer)) {
        return <CareerChangeSurveyBanner />;
    }
    return null;
});
